import { QuestionCircleOutlined } from '@ant-design/icons'
import { Card, Flex, Result, Typography } from 'antd'
import PropTypes from 'prop-types'

const { Text } = Typography

const ErrorCard = ({icon: Icon, iconStyle, title, sub_title, extra}) => {

  return (
    <Flex justify="center" align="center" style={{flexGrow: 1}}>
      <Card variant="outlined" className="error-card">
        <Result align="center"
          icon={Icon ? (
            <Icon className="error-card-icon" style={iconStyle} />
          ) : (
            <QuestionCircleOutlined className="error-card-icon" />
          )}
          title={title}
          subTitle={sub_title}
          extra={extra}
        />
      </Card>
    </Flex>
  )
}

ErrorCard.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string,
  sub_title: PropTypes.string,
  // Actions under the message, e.g. a way back
  extra: PropTypes.node,
}

export default ErrorCard
